// extracted by mini-css-extract-plugin
export default {"card":"V0-z","carouselContainer":"W0-z","carouselContent":"X0-z"};